import { browserSupportsWebAuthn, startAuthentication, startRegistration } from "@simplewebauthn/browser";
import { api } from "./api";

export const passkeysSupported = () => browserSupportsWebAuthn();

export async function loginWithPasskey(): Promise<void> {
  const optionsJSON = await api<Parameters<typeof startAuthentication>[0]["optionsJSON"]>("/auth/passkey/login/options", { body: {} });
  const response = await startAuthentication({ optionsJSON });
  await api("/auth/passkey/login/verify", { body: response });
}

export async function addPasskey(): Promise<void> {
  const optionsJSON = await api<Parameters<typeof startRegistration>[0]["optionsJSON"]>("/auth/passkey/register/options", { body: {} });
  const response = await startRegistration({ optionsJSON });
  await api("/auth/passkey/register/verify", { body: response });
}

/** The user closed the system dialog: not an error worth showing. */
export function isCancelled(error: unknown): boolean {
  return error instanceof Error && (error.name === "NotAllowedError" || error.name === "AbortError");
}
